import { Layout, Typography } from "antd";
import axios from "axios";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import notify from "../../Notification";
import { updateWindowWidth, userSignOut } from "../../appRedux/actions";
import { disableButton } from "../../appRedux/actions/DisableButton";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
} from "../../constants/ThemeSetting";
import App from "../../routes/index";
import ServerURL from "../../service/ServerURL";
import {
  appendExportChunk,
  finalizeExportStream,
  initExportStream,
} from "../../util/CSVandExcelDownload";
import {
  generateFormattedData,
  generateWithdrawReportFormattedData,
} from "../../util/DownloadFormattedData";
import { depositSound, socket } from "../../util/Socket/socketClient";
import {
  handleSocketEvent,
  handleSocketEvent2,
  handleSocketEvent3,
} from "../../util/Socket/socketEventHandler";
import { footerText } from "../../util/config";
import useIdleLogout from "../../util/useIdleLogout";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import Topbar from "../Topbar/index";
import AppSidebar from "./AppSidebar";

const REPORT_TITLES = {
  depositReport: "Deposit Report",
  withdrawReport: "Withdraw Report",
};
const { Content, Footer } = Layout;

const getContainerClass = (navStyle) => {
  switch (navStyle) {
    case NAV_STYLE_DARK_HORIZONTAL:
      return "gx-container-wrap";
    case NAV_STYLE_DEFAULT_HORIZONTAL:
      return "gx-container-wrap";
    case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
      return "gx-container-wrap";
    case NAV_STYLE_BELOW_HEADER:
      return "gx-container-wrap";
    case NAV_STYLE_ABOVE_HEADER:
      return "gx-container-wrap";
    default:
      return "";
  }
};

const getNavStyles = (navStyle, handleSoundUpdate) => {
  switch (navStyle) {
    case NAV_STYLE_DEFAULT_HORIZONTAL:
      return <HorizontalDefault />;
    case NAV_STYLE_DARK_HORIZONTAL:
      return <HorizontalDark />;
    case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
      return <InsideHeader />;
    case NAV_STYLE_ABOVE_HEADER:
      return <AboveHeader />;
    case NAV_STYLE_BELOW_HEADER:
      return <BelowHeader />;
    case NAV_STYLE_FIXED:
      return <Topbar onSoundUpdate={handleSoundUpdate} />;
    case NAV_STYLE_DRAWER:
      return <Topbar onSoundUpdate={handleSoundUpdate} />;
    case NAV_STYLE_MINI_SIDEBAR:
      return <Topbar onSoundUpdate={handleSoundUpdate} />;
    case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
      return <NoHeaderNotification />;
    case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
      return <NoHeaderNotification />;
    default:
      return null;
  }
};

const MainApp = () => {
  const history = useHistory();
  const { navStyle } = useSelector(({ settings }) => settings);
  const { user, initURL } = useSelector(({ auth }) => auth);
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const url = ServerURL.getAPIUrl();
  const streamMeta = useRef({
    reportType: null,
    downloadFormat: null,
    rowCount: 0, // used only to keep "Sr No" continuous across chunks
    started: false,
  });
  const ACTIVITY_KEY = user._id + "_last_user_activity";
  useIdleLogout(ACTIVITY_KEY, user?.panelIdealTime);

  const val = useRef({
    value: localStorage.getItem("sound"),
  });

  const handleSoundUpdate = (value) => {
    val.current = { ...val.current, value: !value };
    // Do something with the updated sound state in MainApp
    //console.log("Sound state updated in MainApp:", value);
    // setEnableSound(value);
    // You can perform any other actions based on the updated state
  };

  const Button = ({ redirectUrl }) => {
    const handleClick = () => {
      history.push(redirectUrl);
    };
    return <a onClick={handleClick}> Click Here</a>;
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      dispatch(updateWindowWidth(window.innerWidth));
    });
  }, [dispatch]);

  const onLogOut = () => {
    localStorage.removeItem("websiteID");
    localStorage.removeItem("user");
    localStorage.removeItem("name");
    localStorage.removeItem("type");
    localStorage.removeItem("id");
    localStorage.removeItem("agent_selected_url");
    localStorage.removeItem("user_token");
    localStorage.removeItem("startDate");
    localStorage.removeItem("endDate");
    localStorage.removeItem("sortByA");
    localStorage.removeItem(ACTIVITY_KEY);
    dispatch(userSignOut());
    window.location.reload();
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      socket.emit("checkUserSession", {
        authorization: localStorage.getItem("user_token"),
        socketId: socket.id,
      });
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    socket.on("connect", () => {
      console.log("Socket connected");
      socket.emit("joinRoom", { userId: user?._id });
    });
    socket.emit("joinRoom", { userId: user?._id });

    socket.on("sessionExpire", () => {
      console.log("session expired");
      onLogOut();
    });

    handleSocketEvent(
      "newDepositRequest",
      (newData) => {
        if (newData) {
          let amount;
          if (newData?.depositAccount?.isUniqueTransaction) {
            amount = newData?.receivedAmount;
          } else {
            amount = newData?.otherCurrency
              ? newData?.otherCurrency?.amount
              : newData?.amount;
          }
          const message = (
            <div>
              You have new deposit request of Rs <strong>{amount}</strong> from{" "}
              <strong>{newData?.user?.endUserId} </strong>{" "}
              <Button redirectUrl="/deposit/queue" />
            </div>
          );
          if (newData?.isManualDepositOrder === true) {
            if (newData?.status === "pending") {
              return;
            } else {
              notify.openNotification(message);
              if (val.current.value === true) {
                depositSound.play();
                console.log("Sound played");
              }
            }
          } else {
            notify.openNotification(message);
            if (val.current.value === true) {
              depositSound.play();
              console.log("Sound played");
            }
          }
          return message;
        }
      },
      handleSoundUpdate,
    );

    handleSocketEvent(
      "newWithdrawRequest",
      (newData) => {
        if (newData) {
          const message = (
            <div>
              You have new{" "}
              {newData?.status === "verified"
                ? "Withdraw Verified Requestd"
                : "Withdraw Pending Requestd"}{" "}
              of Rs <strong>{newData?.amount}</strong> from{" "}
              <strong>{newData?.user?.endUserId}</strong>{" "}
              <Button
                redirectUrl={
                  newData?.status === "verified"
                    ? "/withdraw/queue"
                    : "/withdraw-pending-report"
                }
              />
            </div>
          );
          if (newData?.isManualWithdrawOrder === true) {
            if (newData?.status === "pending") {
              return;
            } else {
              notify.openNotification(message);
              if (val.current.value === true) {
                depositSound.play();
                console.log("Sound played");
              }
            }
          }
          if (newData?.isManualWithdrawOrder === false) {
            notify.openNotification(message);
            if (val.current.value === true) {
              depositSound.play();
              console.log("Sound played");
            }
          }
          return message;
        }
      },
      handleSoundUpdate,
    );

    handleSocketEvent3(
      "commissionStatusChange",
      (newData) => {
        if (newData) {
          const message = (
            <div>
              {newData[1]?.status === "decline"
                ? "Settlement request declined "
                : newData[1]?.status === "completed"
                  ? "Settlement request approved "
                  : "New settlement request "}
              of Rs <strong>{newData[0]?.receiveAmount}</strong>
              {newData[0]?.status === "submitted" ? " from " : " by "}
              <strong>
                {newData[0]?.status === "submitted"
                  ? newData[0]?.from === "vendor"
                    ? newData[0]?.fromId
                    : "TES "
                  : newData[0]?.to === "vendor"
                    ? newData[0]?.toId
                    : "TES "}
              </strong>
              <Button redirectUrl="/commission-summary" />
            </div>
          );
          notify.openNotification(message);
          if (val.current.value === true) {
            depositSound.play();
          }
          return message;
        }
      },
      handleSoundUpdate,
    );

    handleSocketEvent(
      "verifyDepositRequest",
      (newData) => {
        if (newData) {
          if (val.current.value === true) {
            depositSound.play();
          }
          const message = (
            <div>
              You have a request in deposit verification queue{" "}
              <span style={{ fontWeight: "bold" }}>
                {newData?.data?.[0]?.traId}{" "}
              </span>
              <Button redirectUrl={"/deposit-verification-queue"} />
            </div>
          );
          notify.openNotification(message);
          return message;
        }
      },
      handleSoundUpdate,
    );

    handleSocketEvent2("streaming", (newData) => {
      const chunk = newData?.data?.transaction_data;
      if (!newData?.streamingState?.statePage || !chunk || chunk.length === 0) {
        return;
      }
      if (!streamMeta.current.started) {
        const downloadFormat = localStorage.getItem("DownloadFormat");
        const reportType = localStorage.getItem("ReportType");
        streamMeta.current = {
          reportType,
          downloadFormat,
          rowCount: 0,
          started: true,
        };
        initExportStream(
          REPORT_TITLES[reportType] || "Report",
          downloadFormat === "Excel" ? "Excel" : "CSV",
        );
      }

      const { reportType, rowCount } = streamMeta.current;

      // Format ONLY this chunk (not the whole dataset) and keep Sr No
      // continuous using the running rowCount as the offset.
      let formattedChunk = [];
      if (reportType === "depositReport") {
        formattedChunk = generateFormattedData(
          chunk,
          "depositReport",
          undefined,
          undefined,
          undefined,
          rowCount,
        );
      } else if (reportType === "withdrawReport") {
        formattedChunk = generateWithdrawReportFormattedData(
          chunk,
          "withdrawReport",
          undefined,
          rowCount,
        );
      }

      appendExportChunk(formattedChunk);
      streamMeta.current.rowCount += chunk.length;

      // `chunk` and `formattedChunk` fall out of scope here and become
      // eligible for GC — nothing large is retained between events.
    });

    handleSocketEvent2("stream-end", (newData) => {
      dispatch(disableButton(false));
      if (newData?.finish) {
        const { reportType } = streamMeta.current;

        if (streamMeta.current.started) {
          finalizeExportStream();
        }

        notify.successNotification(
          "Download complete",
          `Your ${REPORT_TITLES[reportType] || "-"} is download complete!`,
        );

        localStorage.removeItem("DownloadFormat");
        localStorage.removeItem("ReportType");
        streamMeta.current = {
          reportType: null,
          downloadFormat: null,
          rowCount: 0,
          started: false,
        };
      }
    });

    socket.on("error", (error) => {
      console.error("Socket error:", error);
    });
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const isOperator = user.userType === "operator";
    const canFullFillBoth =
      isOperator &&
      ((user?.operatorAccess?.deposit?.read &&
        user?.operatorAccess?.withdraw?.read) ||
        user.hasFullAccess);
    const canFullFillDeposit =
      isOperator && user?.operatorAccess?.deposit?.read;
    const canFullFillWithdraw =
      isOperator && user?.operatorAccess?.withdraw?.read;
    const isAgnet = user.userType === "agent";
    // Your function to be executed every 10 minutes
    const notificationFunction = async () => {
      try {
        const response = await axios.post(
          url + "/admin/dashboard",
          {},
          {
            headers: {
              Authorization: localStorage.getItem("user_token"),
              "Content-Type": "application/json",
            },
          },
        );
        console.log("response", response.data);
        // setPendingData(response.data?.sec1);
        let submittedDepositCount =
          response?.data?.data?.sec1?.deposit?.submittedDepositCount;
        let submittedWithdrawCount =
          response.data?.data?.sec1?.withdraw?.verifiedWithdrawCount;
        if (response?.data?.status === 200) {
          notify.openNotification(
            <>
              {canFullFillBoth || isAgnet ? (
                <>
                  <Typography.Title level={5}>Deposit</Typography.Title>
                  <Typography.Text
                    onClick={() => history.push("/deposit/queue")}
                    style={{ cursor: "pointer" }}
                  >
                    You have {submittedDepositCount} request pending
                  </Typography.Text>
                </>
              ) : null}

              {canFullFillBoth || isAgnet ? (
                <>
                  <Typography.Title level={5}>Withdraw</Typography.Title>
                  <Typography.Text
                    onClick={() => history.push("/withdraw/queue")}
                    style={{ cursor: "pointer" }}
                  >
                    You have {submittedWithdrawCount} request pending
                  </Typography.Text>
                </>
              ) : null}

              {canFullFillDeposit && (
                <>
                  <Typography.Title level={5}>Deposit</Typography.Title>
                  <Typography.Text
                    onClick={() => history.push("/deposit/queue")}
                    style={{ cursor: "pointer" }}
                  >
                    You have {submittedDepositCount} request pending
                  </Typography.Text>
                </>
              )}

              {canFullFillWithdraw && (
                <>
                  <Typography.Title level={5}>Withdraw</Typography.Title>
                  <Typography.Text
                    onClick={() => history.push("/withdraw/queue")}
                    style={{ cursor: "pointer" }}
                  >
                    You have {submittedWithdrawCount} request pending
                  </Typography.Text>
                </>
              )}
            </>,
          );
        }
      } catch (error) {
        console.log(error);
      }
    };
    // Set up the interval (10 minutes = 600,000 milliseconds)
    const intervalId = setInterval(notificationFunction, 600000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Layout className="gx-app-layout">
      <AppSidebar navStyle={navStyle} />
      <Layout>
        {getNavStyles(navStyle, handleSoundUpdate)}
        <Content
          className={`gx-layout-content ${getContainerClass(navStyle)} `}
        >
          <App match={match} />
          {/* <Footer>
            <div className="gx-layout-footer-content">{footerText}</div>
          </Footer> */}
        </Content>
      </Layout>
      {/* <Customizer /> */}
    </Layout>
  );
};
export default MainApp;
